import { useAppContext } from "../../../../App";
import { authorize } from "../../../../Core";
import { roles } from "../../../../config/constants";
import { useAbmContext } from "../../../../views/abm/useAbmComponent";
import { ActionButton } from "../../../helpers";
import { EditIcon } from "../../../icons";

export const ModificarDesignacionActividad = ({params}) => {
  const { setShowDesignacionAdd, selectedItem } = useAbmContext();
  const { claims: { rol, centros } } = useAppContext();

  const enabled = rol === roles.GESTOR || rol === roles.GESTOR_CENTRAL || rol === roles.LIQUIDADOR || rol === roles.COORDINADOR || rol === roles.COORDINADOR_CENTRAL;

  const handleClick = () => {
    setShowDesignacionAdd({id_actividad: selectedItem.id, id: params.id, observaciones: params.observaciones});
  }
  return <ActionButton iconButton enabled={enabled} Icon={EditIcon} onClick={handleClick}/>
}
